module.exports = __webpack_public_path__ + "static/media/plus_circle.0bdd6713.svg";